import React, { useEffect, useRef, useState } from 'react';
import '../styles/JavascriptExecutorExample.css';

const JavascriptExecutorExample = () => {
  const inputRef = useRef(null);
  const [inputValue, setInputValue] = useState('');
  const [clickMessage, setClickMessage] = useState('');

  const handleClick = () => {
    setClickMessage('Button clicked successfully using JavaScript Executor.');
  };

  useEffect(() => {
    const input = inputRef.current;
    if (!input) {
      return undefined;
    }

    const syncInputValue = () => {
      setInputValue(input.value);
    };

    input.addEventListener('input', syncInputValue);
    input.addEventListener('change', syncInputValue);

    const pollId = window.setInterval(syncInputValue, 250);

    return () => {
      input.removeEventListener('input', syncInputValue);
      input.removeEventListener('change', syncInputValue);
      window.clearInterval(pollId);
    };
  }, []);

  return (
    <div className="js-executor-page" id="javascript-executor-page">
      <section className="js-executor-section" id="enter-text-section">
        <div className="js-executor-card">
          <h3 className="js-executor-section-title">Enter Text</h3>
          <p className="js-executor-behavior">
            Use JavaScript Executor to enter text into the search field below.
          </p>

          <div className="js-executor-action-row">
            <input
              ref={inputRef}
              type="text"
              id="js-executor-text-input"
              name="search_query"
              className="js-executor-input"
              placeholder="Enter search text"
              defaultValue=""
            />

            <div className="js-executor-result-area" id="js-executor-text-result">
              {inputValue ? (
                <p className="js-executor-result" id="js-executor-text-value" role="status">
                  Entered text: {inputValue}
                </p>
              ) : (
                <p className="js-executor-placeholder">Text output will appear here.</p>
              )}
            </div>
          </div>
        </div>
      </section>

      <section className="js-executor-section" id="click-button-section">
        <div className="js-executor-card">
          <h3 className="js-executor-section-title">Click Button</h3>
          <p className="js-executor-behavior">
            Use JavaScript Executor to click the submit button and trigger the action.
          </p>

          <div className="js-executor-action-row">
            <button
              type="button"
              className="js-executor-button"
              id="js-executor-click-button"
              onClick={handleClick}
            >
              Submit Form
            </button>

            <div className="js-executor-result-area" id="js-executor-click-result">
              {clickMessage ? (
                <p className="js-executor-result" id="js-executor-click-message" role="status">
                  {clickMessage}
                </p>
              ) : (
                <p className="js-executor-placeholder">Click result will appear here.</p>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default JavascriptExecutorExample;
